{
  "name": "monsido_frontend",
  "description": "Frontend for monsido",
  "version": "1.12.17",
  "repository": {
    "type": "git",
    "url": "https://github.com/Monsido/frontend.git"
  },
  "type": "module",
  "engines": {
    "node": ">=22.23.4"
  },
  "scripts": {
    "copy:config": "node scripts/setup-config.cjs",
    "serve": "npm run serve:dev",
    "serve:dev:hmr": "node scripts/build-constant.cjs && ng serve --configuration=development --port 3001 --watch",
    "serve:dev": "node scripts/build-constant.cjs && ng serve --configuration=development --port 3001 --watch --no-hmr",
    "serve:devbox": "node scripts/build-constant.cjs --env=devbox && ng serve --configuration=devbox --port 3001 --watch --no-hmr",
    "serve:staging": "node scripts/build-constant.cjs && ng serve --configuration=staging --port 3001 --watch",
    "serve:qa": "node scripts/build-constant.cjs && ng serve --configuration=qa --port 3001 --watch",
    "serve:pentest": "node scripts/build-constant.cjs && ng serve --configuration=pentest --port 3001 --watch",
    "serve:production": "node scripts/build-constant.cjs && ng serve --configuration=production --port 3001 --watch",
    "serve:mfe": "npm run serve:mfe:local",
    "serve:mfe:local": "node scripts/serve-mfe.cjs --env=qa",
    "serve:mfe:qa": "node scripts/serve-mfe.cjs --env=qa",
    "serve:mfe:staging": "node scripts/serve-mfe.cjs --env=staging",
    "serve:mfe:production": "node scripts/serve-mfe.cjs --env=production",
    "build:dev": "node --max_old_space_size=2048 scripts/build.cjs --env=development",
    "build:devbox": "node --max_old_space_size=2048 scripts/build.cjs --env=devbox",
    "build:qa": "node --max_old_space_size=2048 scripts/build.cjs --env=qa",
    "build:staging": "node --max_old_space_size=2048 scripts/build.cjs --env=staging",
    "build:pentest": "node --max_old_space_size=2048 scripts/build.cjs --env=pentest",
    "build:production": "node --max_old_space_size=2048 scripts/build.cjs --env=production",
    "build:mfe:dev": "node scripts/build-mfe.cjs --env=qa",
    "build:mfe:qa": "node scripts/build-mfe.cjs --env=qa",
    "build:mfe:staging": "node scripts/build-mfe.cjs --env=staging",
    "build:mfe:production": "node scripts/build-mfe.cjs --env=production",
    "build:ci:dev": "node scripts/build-ci.cjs --env=development",
    "build:ci:qa": "node scripts/build-ci.cjs --env=qa",
    "build:ci:staging": "node scripts/build-ci.cjs --env=staging",
    "build:ci:pentest": "node scripts/build-ci.cjs --env=pentest",
    "build:ci:production": "node scripts/build-ci.cjs --env=production",
    "prepare": "git config core.hooksPath .githooks || true",
    "pretest": "npm run puppeteer browsers install chrome",
    "test:prepare": "node scripts/test.cjs",
    "test": "npm run test:prepare && npm run test:jest",
    "test:ci": "npm run test:prepare && jest --coverage",
    "test:jest": "jest",
    "test:cc": "jest --coverage",
    "test:fast": "jest --maxWorkers=75% --onlyChanged --passWithNoTests --cache",
    "test:watch": "jest --maxWorkers=50% --watch --onlyChanged --passWithNoTests",
    "test:clear-cache": "jest --clearCache",
    "test:coverage": "npm run test:prepare && npm run test:cc",
    "lint": "npm run lint:ts",
    "ui:login": "playwright test --grep @login --headed --workers=1",
    "ui:diff": "node scripts/ui-diff.cjs",
    "ui:a11y": "node scripts/ui-a11y.cjs",
    "ui:shot": "node scripts/ui-shot.cjs",
    "ui:smoke": "playwright test --grep-invert @login",
    "lint:changed": "node scripts/lint-changed.cjs",
    "lint:ts": "eslint \"src/client/**/*.ts\"",
    "lint:js": "eslint \"src/client/app/**/*.js\"",
    "translate:extract:ts": "sh -c 'node scripts/gettext.cjs --files \"{./src/client/deprecate/frontend-components/src/**/*.+(js|html),./src/client/deprecate/ng-mon-dialog/**/*.+(js),./node_modules/@monsido/angular-shared-components/projects/angular-shared-components/src/**/*.+(html|ts),./src/client/**/*.+(js|html|ts)}\" --exclude \"{./src/client/angularjs-app.js,./src/client/**/*.spec.js}\" --dest ./translation/base.pot --marker-names \"translate,[translate],getString,getPlural,translate-context,translate-plural,translate-comment,translate-args\"'",
    "translate:compile:json": "node scripts/gettext.cjs --compile --files './translation/translations/*.po' --dest './src/client/ng2/core/translation/translations.json' --format json",
    "translate:poedit:get": "node node_modules/@monsido_services/services/mon-poeditor/dist --config=translation-config.json --extract",
    "translate:poedit:sync": "node node_modules/@monsido_services/services/mon-poeditor/dist --config=translation-config.json --sync",
    "t:p:ts": "npm run translate:extract:ts && npm run translate:poedit:sync",
    "t:d:ts": "npm run translate:poedit:get && npm run translate:compile:json",
    "i18n:get": "ts-node ./scripts/i18n-get.ts",
    "i18n:extract": "transloco-keys-manager extract",
    "i18n:sync": "ts-node ./scripts/i18n-sync.ts",
    "i18n:normalize": "ts-node ./scripts/i18n-normalize.ts",
    "i18n:clean": "transloco-keys-manager extract -R && ts-node ./scripts/i18n-clean.ts",
    "bump": "npm run version --patch --no-git-tag-version",
    "bump:minor": "npm run version --minor --no-git-tag-version",
    "bump:major": "npm run version --major --no-git-tag-version",
    "audits": "[ -f audits.json ] && rm audits.json; npm audit --all --json >> audits.json",
    "install-browsers": "node node_modules/puppeteer/install.mjs",
    "api:generate": "openapi-typescript https://staging.monsido.com/api/docs/v1 --output ./src/client/types/api/api.ts --make-paths-enum --path-params-as-types --immutable-types",
    "figma:auth": "figma auth",
    "figma:connect": "figma connect publish",
    "figma:preview": "figma connect preview",
    "figma:parse": "figma connect parse",
    "figma:validate": "figma connect validate"
  },
  "dependencies": {
    "@angular/animations": "^19.2.25",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.25",
    "@angular/compiler": "^19.2.25",
    "@angular/core": "^19.2.25",
    "@angular/forms": "^19.2.25",
    "@angular/localize": "^19.2.25",
    "@angular/platform-browser": "^19.2.25",
    "@angular/platform-browser-dynamic": "^19.2.25",
    "@angular/router": "^19.2.25",
    "@angular/upgrade": "^19.2.25",
    "@fortawesome/fontawesome-pro": "^5.15.4",
    "@jsverse/transloco": "^7.6.1",
    "@monsido_services/services": "git+ssh://git@github.com/Monsido/mon-services.git#1.2.7",
    "@monsido/angular-shared-components": "git+ssh://git@github.com/Monsido/angular-shared-components.git#5.0.9",
    "@monsido/colors": "git+ssh://git@github.com/Monsido/frontend-color-schemas.git#1.0.8",
    "@Monsido/pdf-accessibility-visual-viewer": "github:Monsido/pdf-accessibility-visual-viewer#0.0.9",
    "@monsido/consent-message-encoder": "git+ssh://git@github.com/Monsido/mon-consent-message-encoder.git#1.0.5",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@popperjs/core": "^2.11.8",
    "@primeng/themes": "^19.1.4",
    "@primeuix/themes": "^2.0.2",
    "@uirouter/angular": "^16.1.0",
    "@uirouter/core": "^6.1.1",
    "@uirouter/rx": "^1.0.0",
    "angular-gettext-tools": "^2.5.3",
    "angular2-hotkeys": "^16.0.1",
    "bootstrap": "^5.3.3",
    "chart.js": "^3.3.2",
    "chartjs-adapter-moment": "^1.0.1",
    "deepmerge": "^4.3.1",
    "dompurify": "^3.4.11",
    "flag-icons": "^7.2.3",
    "focus-trap": "^7.6.0",
    "moment": "^2.30.1",
    "mousetrap": "^1.6.5",
    "ng-click-outside2": "^16.0.0",
    "numeral": "^2.0.6",
    "papaparse": "^5.3.2",
    "postcss": "^8.5.10",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.4",
    "privacy_terms": "git+ssh://git@github.com/Monsido/privacy_terms.git#20231102.3",
    "rollbar": "^2.26.5",
    "rxjs": "^7.8.1",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.8.1",
    "undici-types": "^8.3.0",
    "zenscroll": "4.0.2",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-builders/custom-esbuild": "^19.1.0",
    "@angular-builders/custom-webpack": "^19.0.1",
    "@angular-devkit/build-angular": "^19.2.27",
    "@angular-devkit/core": "^19.2.27",
    "@angular/cli": "^19.2.27",
    "@angular/compiler-cli": "^19.2.25",
    "@angular/language-service": "^19.2.25",
    "@figma/code-connect": "^1.3.9",
    "@iplab/ngx-color-picker": "^19.0.3",
    "@jest/globals": "^29.7.0",
    "@jsverse/transloco-keys-manager": "^6.1.0",
    "@playwright/test": "1.63.0",
    "@stylistic/eslint-plugin": "^2.9.0",
    "@types/jest": "^30.0.0",
    "@types/jquery": "^3.5.14",
    "@types/lodash": "^4.17.20",
    "@types/node": "^26.4.0",
    "@types/numeral": "^2.0.5",
    "@types/webpack-env": "^1.18.0",
    "@typescript-eslint/eslint-plugin": "^8.9.0",
    "@typescript-eslint/parser": "^8.9.0",
    "angular-eslint": "^19.3.0",
    "angular-gettext-tools": "^2.5.3",
    "autoprefixer": "^10.4.21",
    "axe-core": "^4.10.0",
    "chokidar": "^4.0.3",
    "concurrently": "^8.2.1",
    "css-loader": "^7.1.4",
    "eslint": "^9.12.0",
    "eslint-plugin-jest": "^29.0.1",
    "fs": "^0.0.1-security",
    "html-minifier-terser": "^7.2.0",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.6.0",
    "jsdom": "^26.1.0",
    "lodash": "^4.18.1",
    "marked": "^14.1.2",
    "ng-mocks": "^14.13.5",
    "node-html-parser": "^6.1.13",
    "node-notifier": "^10.0.1",
    "openapi-typescript": "7.13.0",
    "puppeteer": "^23.5.0",
    "require-dir": "^1.2.0",
    "sass-loader": "^16.0.7",
    "sinon": "^21.0.1",
    "tailwindcss": "^3.4.17",
    "ts-jest": "^29.4.0",
    "ts-loader": "^9.5.7",
    "ts-node": "^10.9.2",
    "typescript": "^5.8.3",
    "typescript-eslint": "^8.36.0",
    "webpack": "^5.106.0",
    "webpack-cli": "^7.0.2",
    "webpack-dev-server": "^5.2.4",
    "yargs": "^17.7.2"
  },
  "overrides": {
    "undici": ">=7.28.0",
    "form-data": ">=4.0.6",
    "piscina": ">=4.9.3",
    "http-proxy-middleware": ">=3.0.7",
    "launch-editor": ">=2.14.1",
    "protobufjs": ">=7.6.3",
    "esbuild": ">=0.28.1",
    "ws": ">=8.20.1",
    "qs": ">=6.15.2",
    "serialize-javascript": ">=7.0.5",
    "uuid": ">=13.0.1",
    "brace-expansion": ">=5.0.6",
    "vite": "~6.4.3",
    "@babel/plugin-transform-modules-systemjs": ">=7.29.4",
    "fast-uri": ">=3.1.2",
    "ip-address": ">=10.1.1",
    "follow-redirects": ">=1.16.0",
    "lodash-es": ">=4.18.0",
    "path-to-regexp": "^0.1.13",
    "handlebars": ">=4.7.9",
    "node-forge": ">=1.4.0",
    "picomatch": ">=4.0.4",
    "cheerio": "^1.0.0-rc.12",
    "glob": "^11.1.0",
    "@angular-devkit/core": {
      "ajv": "^8.18.0"
    },
    "@figma/code-connect": {
      "lodash": ">4.17.23"
    },
    "tar": "^7.5.7"
  }
}
